<template>
<div>
  <el-container>
    <el-header>
      <div class="row m-4">
        <div class="col-md-6">
          <h4>Параметры фильтра</h4>
        </div>
        <div class="col-md-2">
          <el-button type="success" @click="$store.commit('popularItemCreateDialog',true)">Добавить параметры</el-button>
        </div>
      </div>
    </el-header>
    <el-main>
      <el-table
          :data="presetItems"
          style="width: 100%"
          empty-text="Нет данных">
        <el-table-column
            prop="id"
            label="Id"
            width="50">
        </el-table-column>
        <el-table-column
            prop="title"
            label="Название"
        >
        </el-table-column>
        <el-table-column
            label="Значение"
        >
        <template slot-scope="scope">
          <el-row v-if="presetItems[scope.$index].type === typeItem.range.value">
            От <span>{{presetItems[scope.$index].range.min}}</span>
            До <span>{{presetItems[scope.$index].range.max}}</span>
          </el-row>
          <el-row v-else-if="presetItems[scope.$index].values">
            <el-col
              v-for="(item, index) in presetItems[scope.$index].values"
              :key="index"
            >
              {{ item }}
            </el-col>
          </el-row>
        </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="Действия"
            width="200">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="updateRow(scope.$index)">Изменить</el-button>
            <el-button
                size="mini"
                type="danger"
                @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
  <CreatePopularItemDialog
    v-if="$store.getters.popularItemCreateDialog"
    :sectionId="sectionId"
    @changePresetValue="onValuePreset"
   />
  <PopularItemUpdateDialog
    v-if="$store.getters.popularItemUpdateDialog"
    :current-item="getCurrentItem"
    :sectionId="sectionId"
    @changePresetValue="onUpdateValuePreset"
  />
</div>
</template>

<script>
// import axios from "axios";
import CreatePopularItemDialog from "@/components/Popular/CreatePopularItemDialog";
import PopularItemUpdateDialog from "@/components/Popular/UpdatePopularItemDialog";
import typeItem from "@/composable/type/filter-item.type";

export default {
  components: {PopularItemUpdateDialog, CreatePopularItemDialog},
  props: ['items', 'sectionId'],
  data: function (){
    return{
      presetItems:[],
      indexSelectedItem: -1,
      typeItem
    }
  },
  computed: {
    getCurrentItem() {
      if (this.indexSelectedItem >= 0) {
        return this.presetItems[this.indexSelectedItem]
      }
      return undefined
    },
  },
  watch: {
    items() {
      this.initPresetItems()
    }
  },
  methods:{
    initPresetItems() {
      if (this.items && this.items.length > 0) {
        this.presetItems = this.items;
      } else {
        this.presetItems = []
      }
    },
    setPresetItem(value, index) {
      if (!value) return;
      if (index !== undefined && index >= 0) {
        if (this.presetItems[index]) {
          this.presetItems.splice(index, 1, value)
        }
      } else {
        const findResult = this.presetItems.findIndex((e) => e.id === value.id)
        if (findResult < 0) {
          this.presetItems.push(value)
        } else {
          this.presetItems.splice(findResult, 1, value)
        }
      }
      this.emitChange()
    },
    deleteRow: function (index) {
      this.presetItems.splice(index, 1)
      this.emitChange()
    },
    updateRow: function (index) {
      this.indexSelectedItem = index;
      this.$store.commit('popularItemUpdateDialog', true);
    },
    emitChange: function() {
      this.$emit('changeItems', [...this.presetItems])
    },
    onValuePreset: function(value) {
      this.setPresetItem(value)
    },
    onUpdateValuePreset: function(value) {
      this.setPresetItem(value, this.indexSelectedItem)
      this.indexSelectedItem = -1;
    }
  }
}
</script>

<style scoped>

</style>